// extracted by mini-css-extract-plugin
var _1 = "stat-diff__ZaVMw";
var _2 = "stat-extended-diff__O4ooy";
var _3 = "title__IreX4";
export { _1 as "statDiff", _2 as "statExtendedDiff", _3 as "title" }
